var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArIcon = function SvgBackArIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.68 7.77a1.09 1.09 0 0 0 0-1.543L10.234.782a1.09 1.09 0 0 0-1.542 1.542l3.591 3.587H1.841a1.088 1.088 0 1 0 0 2.178H12.28l-3.584 3.588a1.09 1.09 0 0 0 1.542 1.541l5.445-5.445z"
  })));
};
export default SvgBackArIcon;